import React from 'react';
import { useData } from '../store/DataContext';
import { AdminDashboard } from './admin/AdminDashboard';
import { ReceptionDashboard } from './reception/ReceptionDashboard';
import { NursingDashboard } from './nursing/NursingDashboard';
import { ClinicianDashboard } from './clinician/ClinicianDashboard';
import { LaboratoryDashboard } from './laboratory/LaboratoryDashboard';
import { RadiologyDashboard } from './radiology/RadiologyDashboard';
import { PharmacyDashboard } from './pharmacy/PharmacyDashboard';
export const DashboardRouter: React.FC = () => {
  const {
    currentUser
  } = useData();
  if (!currentUser) return null;
  switch (currentUser.role) {
    case 'Administrator':
      return <AdminDashboard data-id="element-802" />;
    case 'Reception':
      return <ReceptionDashboard data-id="element-803" />;
    case 'Nursing':
      return <NursingDashboard data-id="element-804" />;
    case 'Clinician':
      return <ClinicianDashboard data-id="element-805" />;
    case 'Laboratory':
      return <LaboratoryDashboard data-id="element-806" />;
    case 'Radiology':
      return <RadiologyDashboard data-id="element-807" />;
    case 'Pharmacy':
      return <PharmacyDashboard data-id="element-808" />;
    default:
      return <div data-id="element-809">Unknown role</div>;
  }
};